import { render, staticRenderFns } from "./MessengerIntegrationsModal.vue?vue&type=template&id=4260e080"
import script from "./MessengerIntegrationsModal.vue?vue&type=script&lang=js"
export * from "./MessengerIntegrationsModal.vue?vue&type=script&lang=js"
import style0 from "./MessengerIntegrationsModal.vue?vue&type=style&index=0&id=4260e080&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports